import Carousel from "../Carousel/Carousel";
import styles from "./Yoga.module.css";

const yogaData = [
  {
    id: 1,
    img: require("../../assets/images/yoga-img-1.png"),
    alt: "",
  },
  {
    id: 2,
    img: require("../../assets/images/yoga-img-2.png"),
    alt: "",
  },
  {
    id: 3,
    img: require("../../assets/images/yoga-img-3.png"),
    alt: "",
  },
  {
    id: 4,
    img: require("../../assets/images/yoga-img-4.png"),
    alt: "",
  },
];

const Yoga = () => {
  return <Carousel className={styles.section} title="Yoga" data={yogaData} />;
};

export default Yoga;
